<template>
  <div class="moderator-candidate-resumes__table-row  _head">
    <div class="moderator-candidate-resumes__table-cell  _head  _id">
      {{ $tModeratorCandidates('ID') }}
    </div>
    <div class="moderator-candidate-resumes__table-cell  _head">
      {{ $tModeratorCandidates('Customer') }}
    </div>

    <div class="moderator-candidate-resumes__table-cell  _head  _status">
      {{ $tModeratorCandidates('Status') }}
    </div>
    <div class="moderator-candidate-resumes__table-cell  _head  _uploaded-passport">
      {{ $tModeratorCandidates('Are all passport spreads loaded?') }}
    </div>
    <div class="moderator-candidate-resumes__table-cell  _head  _moderated-passport">
      {{ $tModeratorCandidates('Has your passport been checked?') }}
    </div>
    <div class="moderator-candidate-resumes__table-cell  _head  _have-responds">
      {{ $tModeratorCandidates('Are there any responses?') }}
    </div>
    <div class="moderator-candidate-resumes__table-cell  _head  _filled-resume">
      {{ $tModeratorCandidates('Application completion status') }}
    </div>
    <div class="moderator-candidate-resumes__table-cell  _head  _have-interaction">
      {{ $tModeratorCandidates('On interaction') }}
    </div>
    <div class="moderator-candidate-resumes__table-cell  _head  _toggle">

    </div>
  </div>
</template>

<script>
  export default {
    name: 'AMCandidatesResumesPageResumeItemRowHead',
    data() {
      return {}
    }
  }
</script>

<style lang="less">

</style>
